import useTranslation from "next-translate/useTranslation";
import { useToast } from "@chakra-ui/react";
import { useSentry } from "src/services/Sentry";

export const useStripeToast = () => {
  const toast = useToast();
  const { log } = useSentry();
  const { t } = useTranslation();

  return {
    sendStripeErrorToast: (stripeErrorCode: string) => {
      let description: string;

      switch (stripeErrorCode) {
        case "invalid_request_error":
          description = t("smile:signup_invalidRequestError");
          break;
        case "Your card was declined.": // TODO: switch to `case "card_declined"` when server sends good errors:
          description = t("smile:signup_cardDeclined");
          break;
        default:
          log(`Unhandled stripe error code : ${stripeErrorCode}`, "error");
          description = stripeErrorCode;
          break;
      }
      toast({
        position: "top",
        title: t("smile:signup_stripeErrorTitle"),
        description,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    },
    sendSuccessToast: () =>
      toast({
        position: "top",
        title: t("smile:signup_stripeSuccessTitle"),
        status: "success",
        duration: 9000,
        isClosable: true,
      }),
  };
};
